import*as e from"react";import r from"./index.module.scss.js";var t=function(t){var a=t.helpText,l=t.id;return a?e.createElement("p",{className:r.helperText,id:l},a):null};export{t as InputHelpText};
//# sourceMappingURL=InputHelpText.js.map
